import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import theme config.
import ThemeConfig from '@config/theme';
// Import enumerations
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		Claims_container: {
			display: 'flex',
			flexDirection: 'column',
			height: '100%'
		},
		Claims_formWrapper: {
			flex: '1 0',
			minHeight: 0,
		},
		Claims_header: {
			backgroundColor: ThemeConfig.primaryColor,
			color: ThemeConfig.primaryContrastTextColor,
			fontSize: '1.3rem',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			padding: theme.spacing(3, 0),
			'& > h1': {
				fontWeight: '400',
				fontSize: '3.5rem',
				margin: 0,
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					fontSize: '1.5rem'
				},
			},
			'& > h3': {
				fontWeight: '300',
				fontSize: '1.25rem',
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					fontSize: '1rem',
				},
			}
		},
		Claims_header_with_policyId: {
			backgroundColor: ThemeConfig.primaryColor,
			color: ThemeConfig.primaryContrastTextColor,
			padding: theme.spacing(3),
			margin: 0,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			'& > p.leftHeader': {
				marginRight: 'auto',
				marginTop: 0,
				marginBottom: 0,
				visibility: 'hidden',
				fontWeight: '500',
				fontSize: '1.5rem',
				[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
					display: 'none'
				}
			},
			'& > p.rightHeader': {
				marginLeft: 'auto',
				marginTop: 0,
				marginBottom: 0,
				fontWeight: '500',
				fontSize: '1.5rem',
				[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
					fontSize: '1.25rem'
				}
			},
			'& > p': {
				display: 'flex'
			},
			'& > p.middleHeader': {
				fontWeight: '400',
				fontSize: '3.5rem',
				margin: 0,
				paddingLeft: theme.spacing(3),
				[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
					fontSize: '1.5rem',
					paddingLeft: 0
				},
			}
		},
		Claims_bodyHeader: {
			textAlign: 'center',
			width: '100%',
			'& > h1': {
				fontWeight: 400,
				fontSize: '2.5rem',
				lineHeight: '2.5rem',
				textAlign: 'center',
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					textAlign: 'left'
				},
			},
			'& > h3': {
				fontWeight: 300,
				fontSize: '1.75rem',
				lineHeight: '2.5rem',
				textAlign: 'center',
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					textAlign: 'justify'					
				},
			}
		},
		Claims_body: {
			minHeight: 0,
			height: '100%',
			display: 'flex',
			fontSize: '1.25rem',
			flexDirection: 'column',
			'& div#claimsForm section[class*="InputMultipleFile-inputMultipleFile"]': {
				width: '100%',
				'& div#claimPictures': {
					color: ThemeConfig.primaryColor,
					borderColor: ThemeConfig.primaryColor,
					backgroundColor: ThemeConfig.lightBlue
				},
				'& div[class*="InputMultipleFile-inputMultipleFile_helperText"]': {
					fontSize: '1rem'
				},
				'& div[class*="InputMultipleFile-inputMultipleFile_helperTextError"]': {
					textAlign: 'center',
					padding: theme.spacing(0, 0, 1, 0)
				},
				'& div[class*="InputMultipleFile-inputMultipleFile_label"]': {
					flexDirection: 'row',
					justifyContent: 'center'
				},
				'& div[class*="InputMultipleFile-inputMultipleFile_divBreak"]': {
					width: '100%'
				},
				'& div[class*="InputMultipleFile-inputMultipleFile_fileNameBody"]': {
					margin: theme.spacing(1, 0),
					padding: theme.spacing(1),
					border: '2px solid',
					backgroundColor: ThemeConfig.primaryContrastTextColor,
					justifyContent: 'center'
				},
				'& div#claimPictures div[class*="InputMultipleFile-inputMultipleFile_messageBody"]': {
					flexDirection: 'column',
					alignItems: 'center',
					'& div[class*="InputMultipleFile-inputMultipleFile_messageTextBody"]': {
						padding: theme.spacing(0, 0, 2, 0),
					},
					'& div[class*="InputMultipleFile-inputMultipleFile_inputBtnWrapper"]': {
						padding: theme.spacing(0, 0, 4, 0),
						'& div[class*="InputMultipleFile-inputMultipleFile_inputBtn"] > button': {
							backgroundColor: ThemeConfig.primaryContrastTextColor,
							color: ThemeConfig.primaryColor,
							borderColor: ThemeConfig.primaryColor,
							border: '2px solid'
						}
					}
				}
			},
			'& p#lossDate-helper-text': {
				color: ThemeConfig.errorColor
			},
			'& div.disclosuresContainer': {
				fontSize: '1.25rem',
				display: 'flex',
				paddingTop: 0,
				margin: 'auto',
				width: '80%',
				'& ul': {
					padding: theme.spacing(0, 0, 3, 0),
					margin: 0
				},
				'& li': {
					padding: theme.spacing(3, 0)
				},
				'& p, span': {
					fontSize: '1.25rem'
				},
				'& label': {
					margin: theme.spacing(0, 0, 0, -4.5)
				}
			},
			'& div.postClaimStepContainer': {
				display: 'flex',
				flexDirection: 'column',
				margin: 'auto',
				width: '70%',
				'& > div': {
					display: 'flex',
					flexWrap: 'nowrap',
					fontSize: '1.25rem'
				},
				'& span.step': {
					fontSize: '2.5rem',
					fontWeight: '500',
					padding: theme.spacing(3)
				},
				'& span.stepText': {
					display: 'flex',
					alignItems: 'center'
				}
			},
			'& div.claimInfoContainer': {
				fontSize: '1.25rem',
				'& p': {
					padding: theme.spacing(1.5),
					margin: 0
				},
				'& div[class*="Claims_wholeRow"]': {
					padding: 0
				}
			},
			'& table#allClaimsTable th': {
				textAlign: 'center'
			},
			'& table#allClaimsTable td': {
				textAlign: 'center'
			}
		},
		Claims_wholeRow: {
			padding: theme.spacing(3, 1.5),
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
			flexDirection: 'column',
		},
		Claims_wholeRowColumn: {
			padding: theme.spacing(0, 1.5),
			width: '100%',
		},
		Claims_wholeRow_twoThirds_width: {
			padding: theme.spacing(3, 0),
			width: `${100 / 1.5}%`,
			display: 'flex',
			flexWrap: 'wrap',
			margin: 'auto'
		},
		Claims_fourRowColumnContainer: {
			margin: theme.spacing(3, 0),
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				width: `25%`
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				width: `100%`
			},
		},
		Claims_fourRowColumn: {
			padding: theme.spacing(0, 1.5),
		},
		Claims_previousLossDocumentLink: {
			textDecoration: 'none',
			color: theme.palette.primary.main
        }
	});
}

export default styles;